import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Icon, Loader } from '..';
import './styles.scss';

const renderPhoto = () => false;

const Header = (props) => {
  const [menuIndicatedOpened, setMenuIndicatedOpened] = useState(false);
  const wrapperRef = useRef(null);

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      /**
         * Alert if clicked on outside of element
         */
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setMenuIndicatedOpened(false);
        }
      };

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  useOutsideAlerter(wrapperRef);

  return (
    <header className="header__container">
      <div className="header__page__name">
        <span>{props.pageName}</span>
      </div>
      <button
        ref={wrapperRef}
        className="header_user__button"
        onClick={() => {
          setMenuIndicatedOpened(!menuIndicatedOpened);
        }}
      >
        {renderPhoto() || (
        <div className="header_user__no__photo">
          <Icon name="user" />
        </div>
        )}
        {props.userData.data ? (
          <span className="header_user__name">{props.userData.data.email}</span>
        ) : (
          <div className="header_user__name">
            <Loader type="small-loader" />
          </div>
        )}
        <div className="header_user__arrow">
          <Icon name="arrow-down" />
        </div>
        <div ref={wrapperRef} className="header__dropdown__menu" style={menuIndicatedOpened ? { display: 'flex' } : {}}>
          <Link to="/my">My account</Link>
          <button onClick={() => { props.signOut(); props.history.push('/'); }}>
            <span>Log out</span>
            <Icon name="exit" />
          </button>
        </div>
      </button>
    </header>
  );
};

Header.propTypes = {
  userData: PropTypes.object,
  pageName: PropTypes.string,
  signOut: PropTypes.func,
  history: PropTypes.object,
};
Header.defaultProps = {
  userData: {},
  pageName: '',
  signOut: () => {},
  history: {},
};

const mapStateToProps = (state) => ({
  userData: state.user,
});

export default connect(
  mapStateToProps,
  null,
)(Header);
